import { Component, OnInit } from "@angular/core";

import { Observable } from "rxjs";

import { DokumentListeSandbox } from "./dokument-liste.sandbox";
import { DokumentListeViewModel } from "./dokument-liste.view-model";

@Component({
    selector: "dokument-liste",
    templateUrl: "./dokument-liste.component.html",
    styleUrls: ["./dokument-liste.component.scss"]
})
export class DokumentListeComponent implements OnInit {
    public readonly visteKolonner: string[] = ["overskrift", "dato"];
    public vm$: Observable<DokumentListeViewModel>;

    constructor(private readonly sandbox: DokumentListeSandbox) {}

    public ngOnInit(): void {
        this.vm$ = this.sandbox.hentViewModel();
    }
}
